import {
  MODULATION_TECHNIQUES,
  SOURCE_KEY_POOL,
  getValidDestinations,
} from '@tunasong/music-lib'
import type { ModulationTechnique, SourceKey } from '@tunasong/music-lib'

export type ModulationSubMode = 'explore' | 'quiz'

export const parseModulationSubMode = (value: string | null): ModulationSubMode | null => {
  if (value === 'explore' || value === 'quiz') {return value}
  return null
}

export const parseSourceKey = (value: string | null): SourceKey | null => {
  if (!value) {return null}
  return (SOURCE_KEY_POOL as readonly string[]).includes(value) ? (value as SourceKey) : null
}

export const parseTechnique = (value: string | null): ModulationTechnique | null => {
  if (!value) {return null}
  return (MODULATION_TECHNIQUES as readonly string[]).includes(value)
    ? (value as ModulationTechnique)
    : null
}

export const parseDestinationKey = (
  value: string | null,
  source: SourceKey | null,
  technique: ModulationTechnique | null
): string | null => {
  if (!value || !source || !technique) {return null}
  const valid = getValidDestinations(source, technique)
  return valid.includes(value) ? value : null
}
